subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    RemoveLocalData();
});
function RemoveLocalData(){
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        if (cart.item_count === 0) {
            removeOhnutsInfoPS("ohnuts_cart_token");
            removeOhnutsInfoPS("ohnuts_cart_items");
            removeOhnutsInfoPS("ohnuts_multi_address_info");
            removeOhnutsDiscountInfoPB();
            removeOhntsinfoVarientPB();
        }
    });
  }
  function removeOhnutsInfoPS(infoKey) {
    const driver = storedriver();
    driver.removeItem(infoKey);
  }
  function storedriver() {
    return window.localStorage;
  }
  function removeOhnutsDiscountInfoPB(){
    localStorage.removeItem("couponCode");
    localStorage.removeItem("freeShipping");
    localStorage.removeItem("discountNode");
  }
  function removeOhntsinfoVarientPB(){
    localStorage.clear();
  }